import { render, staticRenderFns } from "./IntegracaoIPM.vue?vue&type=template&id=d06a80d8"
import script from "./IntegracaoIPM.vue?vue&type=script&lang=js"
export * from "./IntegracaoIPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports